import {ActionList} from '@primer/react'

import type {PickerRepository, PickerScope} from '../types'
import {ListItemRepoIcon} from './ListItemRepoIcon'

type ScopeType = PickerScope['type']

interface PickerListProps {
  mode: 'single' | 'multiple'
  scopeType: ScopeType
  items: PickerRepository[]
  selectedItems: PickerRepository[]
  setSelectedItems: (repositories: PickerRepository[]) => void
}

export function PickerList({mode, items, selectedItems, setSelectedItems, scopeType}: PickerListProps) {
  const selectedIds = new Set(selectedItems.map(repo => repo.id))

  const onSelectItem = (repo: PickerRepository) => {
    const isSelected = selectedIds.has(repo.id)

    if (isSelected) {
      setSelectedItems(selectedItems.filter(item => item.id !== repo.id))
    } else {
      setSelectedItems(mode === 'single' ? [repo] : [...selectedItems, repo])
    }
  }

  return (
    <ActionList selectionVariant={mode} role="listbox" aria-label="Repository List">
      {items.map(repo => (
        <ActionList.Item
          key={repo.id}
          role="option"
          selected={selectedIds.has(repo.id)}
          onSelect={() => onSelectItem(repo)}
        >
          <ActionList.LeadingVisual>
            <ListItemRepoIcon visibility={repo.visibility} />
          </ActionList.LeadingVisual>
          {getRepoName(repo, scopeType)}
        </ActionList.Item>
      ))}
    </ActionList>
  )
}

export function getRepoName(repo: PickerRepository, scopeType: ScopeType) {
  const showRepoOwner = scopeType !== 'organization' && scopeType !== 'user'
  if (showRepoOwner && repo.ownerLogin) {
    return `${repo.ownerLogin}/${repo.name}`
  }
  return repo.name
}

try{ PickerList.displayName ||= 'PickerList' } catch {}